import { connect } from 'react-redux'
import { emptyArray } from 'utils'

import TableStores from './TableStores'

const mapStateToProps = ({ countries, ui }, { countryId }) => {
  const selectedCountry = countryId ? countries.list.find(country => country.countryId === countryId) : []
  const stores = selectedCountry && selectedCountry.stores

  return {
    data: stores || emptyArray,
    isFetching: ui.countryStores.isFetching,
  }
}

export default connect(mapStateToProps)(TableStores)
